<div class="wrapper">
  <mat-tab-group>
    <mat-tab label="Информация">
      <div class="mainInfo">
        <div class="img">
          <!-- <app-product-image-carousel [product]="product"></app-product-image-carousel> -->
        </div>
        <div class="barcodes">
          <button mat-flat-button color="primary" class="btnAddBarcode" (click)="addBarcode()">
            <mat-icon>qr_code_2</mat-icon> Добавить штрих-код
          </button>
          <mat-list>
            <mat-list-item *ngFor="let barcode of product?.barcodes"
              ><button mat-icon-button color="warn" (click)="deleteBarcode(barcode.barcode)">
                <mat-icon>clear</mat-icon></button
              >{{ barcode.barcode }}
            </mat-list-item>
          </mat-list>
        </div>
        <div class="info">
          <form [formGroup]="updateForm" class="updateForm" (ngSubmit)="save()">
            <div>
              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>Наименование</mat-label>
                <input matInput placeholder="Наименование" formControlName="description" />
                <mat-icon matSuffix>assignment</mat-icon>
              </mat-form-field>
              <app-brand-selector [control]="brandControl"></app-brand-selector>
              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>Артикул</mat-label>
                <input matInput placeholder="Артикул" formControlName="article" />
                <mat-icon matSuffix>view_headline</mat-icon>
              </mat-form-field>
              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>Штрих-код</mat-label>
                <input matInput placeholder="Штрих-код" formControlName="barcode" />
                <mat-icon matSuffix>qr_code</mat-icon>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="fullWidth" appearance="outline" floatLabel="always">
                <mat-label>Розница</mat-label>
                <input matInput type="number" placeholder="Розница" formControlName="retail" />
                <mat-icon matSuffix>sell</mat-icon>
              </mat-form-field>
              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>Адрес</mat-label>
                <input matInput placeholder="Адрес" [formControl]="cellFormControl" />
                <mat-icon matSuffix>home</mat-icon>
              </mat-form-field>
              <app-folder-selector [control]="folderControl"></app-folder-selector>
              <div class="btnHolder">
                <button mat-flat-button type="submit" color="primary">Сохранить</button>
                <button mat-flat-button color="warn" type="button" (click)="deleteProduct()">
                  Удалить
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Характеристики">
      <div class="props"></div>
    </mat-tab>
  </mat-tab-group>
</div>
